import React from 'react';

import Bull from '../../../components/BulletSeparator';
import { PrivacyPolicyLink, UserNoticeLink } from '../../../components/links';
import { RecaptchaNotice } from '../../../components/ReCaptchaContainer';
import { OidcContext } from '../../../types';
import { isMobileOidc } from '../../../utilities/oidc/oidc';
import { RecaptchaNoticeContainer } from './styled';

const Footer = ({
  isEmbedded,
  oidcContext,
}: {
  isEmbedded: boolean;
  oidcContext: OidcContext | undefined;
}) => {
  if (isEmbedded) return null;

  return (
    <>
      <ul className="fine-print">
        <li>
          <PrivacyPolicyLink isMobileLink={isMobileOidc(oidcContext)} />
        </li>
        <Bull />
        <li>
          <UserNoticeLink isMobileLink={isMobileOidc(oidcContext)} />
        </li>
      </ul>
      <RecaptchaNoticeContainer>
        <RecaptchaNotice />
      </RecaptchaNoticeContainer>
    </>
  );
};

export default Footer;
